






















import * as Routes from '@/browser/routes';
import { Component, Vue } from 'vue-property-decorator';
import PasswordDAO from '@/browser/dao/PasswordDAO';

@Component
export default class RoomPasswordPage extends Vue {
  password: string | null = null;

  async join() {
    const { password } = this;

    if (!await this.$validator.validateAll() || !password) return;

    const passwordDAO = new PasswordDAO();
    await passwordDAO.update({ password });

    this.$router.push({ name: Routes.Room.name, params: { roomId: passwordDAO.roomId } });
  }

  cancel() {
    this.$router.push({ name: Routes.Lobby.name });
  }
}
